<mat-toolbar
  role="header"
  [hidden]="showSearchBox"
  color="primary"
  class="mat-elevation-z6"
  [fxLayout.lt-md]="minimal ? 'row' : 'column'"
  [fxLayoutAlign.lt-md]="minimal ? 'space-between center' : 'start stretch'"
  fxLayout="row"
  [ngStyle.lt-md]="minimal ? '' : 'height:auto'"
  fxLayoutAlign="space-between center"
>
  <button
    id="menuButton"
    *ngIf="header.showMenu$ | async"
    mat-icon-button
    (click)="side.toggleSideMenu(null)"
  >
    <mat-icon>menu</mat-icon>
  </button>
  <button
    id="searchButton"
    [fxHide.lt-md]="minimal"
    *ngIf="searchService.enableSearch"
    mat-button
    (click)="showSearchBox = true"
  >
    <mat-icon>search</mat-icon>
    <span i18n>Search</span>
    <span>{{ searchText ? ' - ' + searchText! : '' }}</span>
  </button>
  <button
    *ngIf="searchText && searchService.enableSearch"
    class="small"
    mat-icon-button
    data-action="clear-search"
    matTooltipPosition="after"
    matTooltipShowDelay="500"
    i18n-matTooltip
    matTooltip="Clear Search Filter"
    (click)="search(''); searchText = ''"
  >
    <mat-icon>zoom_out</mat-icon>
  </button>
  <div
    [fxHide.lt-md]="minimal"
    ngClass="header-start"
    fxLayout="row"
    fxLayoutAlign="space-around center"
    ngClass.lt-md=""
    fxFlexAlign="center"
  >
    <ng-container #startItems></ng-container>
    <ng-content select="[pcpStartItems]"></ng-content>
  </div>
  <div
    ngClass="main-title"
    [ngClass.lt-md]="minimal ? 'main-title' : ''"
    fxFlexAlign.lt-md="center"
    class="noselect"
    fxLayout="row"
    fxLayoutAlign="start center"
  >
    <mat-icon [fontSet]="header.mainIconFontSet" style="margin: 6px">{{
      header.mainIcon
    }}</mat-icon>
    <span id="fullTitle" *ngIf="middleItemsCount === 0" fxShow.xs="false"
      >{{ header.appShortName }} {{ currentModule ? '-' : '' }}
      {{ currentModule }}</span
    >
    <span
      *ngIf="
        middleItemsCount > 0 &&
        (!searchService.enableSearch ||
          !breakpointObserver.isMatched('screen and (max-width: 1279px)'))
      "
      fxHide.xs="true"
      >{{ header.appShortName }} -
    </span>
    <span *ngIf="middleItemsCount === 0" fxShow.xs="true" fxShow="false">{{
      header.appShortName
    }}</span>
    <ng-container #middleItems></ng-container>
  </div>
  <div [fxHide.lt-md]="minimal" style="overflow: hidden" fxFlexAlign="center">
    <ng-container #endItems></ng-container>
    <ng-content select="[pcpEndItems]"></ng-content>
  </div>
  <button
    [fxHide.lt-md]="minimal"
    ngStyle.lt-md="margin: auto;"
    *ngIf="(header.showMenu$ | async) && !header.disableNotifications"
    mat-icon-button
    [matMenuTriggerFor]="notificationsMenu"
    (contextmenu)="openSoundsMenu($event)"
  >
    <mat-icon
      aria-hidden="false"
      id="notificationsIcon"
      class="icon-animated-bell"
      [matBadge]="newNotifications$ | async"
      matBadgeColor="accent"
      >notifications</mat-icon
    >
    <span [matMenuTriggerFor]="soundsMenu"></span>
  </button>
  <button
    fxHide.gt-sm="true"
    fxFlexAlign="center"
    (click)="minimal = !minimal"
    *ngIf="header.showMenu$ | async"
    mat-icon-button
  >
    <mat-icon>{{ minimal ? 'expand_more' : 'expand_less' }}</mat-icon>
  </button>
</mat-toolbar>
<mat-form-field
  *ngIf="showSearchBox"
  id="search-box"
  #searchBox
  color="primary"
  class="mat-elevation-z8"
  fxFlex
  fxFlexFill
>
  <mat-label i18n>Search</mat-label>
  <input
    matInput
    type="text"
    (blur)="showSearchBox = false"
    [placeholder]="searchPlaceHolder"
    [(ngModel)]="searchText"
    (keyup)="search($any($event.target).value)"
    [matAutocomplete]="auto"
    #searchInput
  />
  <mat-icon
    *ngIf="!speech.speechSupported"
    class="form-icon"
    (mousedown)="$event.preventDefault()"
    matPrefix
    >search</mat-icon
  >
  <mat-icon
    *ngIf="speech.speechSupported"
    id="voice-input"
    (mousedown)="$event.preventDefault()"
    (click)="searchByVoice()"
    class="form-icon"
    matPrefix
    >keyboard_voice</mat-icon
  >
  <mat-icon class="form-icon" id="close-search" matSuffix (click)="search('')"
    >close</mat-icon
  >
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option
      *ngFor="let completion of completionOptions$ | async"
      [value]="completion.value ? completion.value : completion.text"
      (onSelectionChange)="performCompletionAction(completion)"
      (mousedown)="$event.preventDefault()"
    >
      <mat-icon
        color="primary"
        *ngIf="completion.svgIcon"
        [svgIcon]="completion.svgIcon"
      ></mat-icon>
      <mat-icon color="primary" *ngIf="completion.icon">{{
        completion.icon
      }}</mat-icon>
      <span>{{ completion.text }}</span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
<mat-menu
  class="wide-menu"
  #notificationsMenu
  [overlapTrigger]="false"
  (closed)="checkAlerts()"
>
  <button
    class="mat-typography"
    *ngFor="let notification of notifications$ | async"
    (click)="notification.action(notification.id)"
    mat-menu-item
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="15px"
  >
    <mat-icon
      [attr.color]="notification.iconColor"
      [color]="notification.iconColor"
      >{{ notification.icon }}</mat-icon
    >
    <div fxLayout="column" fxLayoutAlign="center start">
      <span
        [style.font-weight]="!notification.isRead ? 'bold' : 'normal'"
        class="mat-subtitle-2"
        [matTooltip]="notification.text.length > 60 ? notification.text : ''"
        >{{ notification.text }}</span
      >
      <span class="mat-caption">{{ notification.timeText }}</span>
    </div>
  </button>
  <button
    mat-menu-item
    *ngIf="!!!notifications$ || (notifications$ | async)?.length === 0"
  >
    <mat-icon>notifications_off</mat-icon>
    <span i18n>No new notifications</span>
  </button>
</mat-menu>
<mat-menu id="soundsMenu" #soundsMenu>
  <button mat-menu-item (click)="chooseSound(null)">
    <mat-icon>{{ selectedNotificationSound ? 'volume_off' : 'done' }}</mat-icon>
    <span i18n>None</span>
  </button>
  <button
    *ngFor="let sound of header.availableSounds"
    mat-menu-item
    (click)="chooseSound(sound)"
  >
    <mat-icon>{{
      selectedNotificationSound === sound.source ? 'done' : 'music_note'
    }}</mat-icon>
    <span>{{ sound.title }}</span>
  </button>
</mat-menu>
